import { EventEmitter, Injectable, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { SetGrouping } from '../../../store/actions/previous-states-actions';
import { IListSummaryModalEventObj } from '../../modals/list-summary/list-summary-modal.component';
import { IListViewData } from '../../typings/interfaces/list-view.interface';
import { ICurrentGrouping } from '../prev-state/prev-state.service';

@Injectable()
export class ListSummaryGroupings {
  // tslint:disable-next-line:contextual-decorator
  @Output() groupingNavEvent$: EventEmitter<IListSummaryModalEventObj> = new EventEmitter<IListSummaryModalEventObj>();

  constructor(private store: Store<any>) {
    //
  }

  public setGroupings(madLibModel, groupings$: Observable<Partial<IListViewData>>) {
    if (groupings$) {
      const groupHumanName = madLibModel.Groupings ? madLibModel.Groupings.human : madLibModel.Dimension2.human;
      groupings$.pipe(take(1)).subscribe(grouping => {
        this.store.dispatch(new SetGrouping({ grouping, groupHumanName } as ICurrentGrouping));
      });
    }
  }

  public setGroupingsV2(madLibModel, grouping) {
    if (grouping) {
      const groupHumanName = madLibModel.grouping ? madLibModel.grouping.human : madLibModel.focus.human;
      this.store.dispatch(new SetGrouping({ grouping, groupHumanName } as ICurrentGrouping));
    }
  }

  public getExportListData({ groupings, columns, madlibModel, listType }) {
    return {
      listType,
      groupings,
      madlibSelections: madlibModel.value,
      columns,
    };
  }
}
